"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TileCompact = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const TileCompact = ({ fill = "#E6E6E6", size = 16, title = "Compact view" }) => (react_1.default.createElement(Base_1.Base, { size: size, smooth: false, fill: fill, title: title },
    react_1.default.createElement("path", { d: "M7,7H1V5h6V7ZM15,5H9v2h6V5ZM7,1H1v2h6V1ZM15,1H9v2h6V1ZM7,9H1v2h6V9ZM15,9H9v2h6V9ZM7,13H1v2h6V13ZM15,13H9v2h6V13Z" })));
exports.TileCompact = TileCompact;
//# sourceMappingURL=TileCompact.js.map